import script from "./PaymentReceiptCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentReceiptCard.vue?vue&type=script&setup=true&lang=js"

import "./PaymentReceiptCard.vue?vue&type=style&index=0&id=31c6829a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31c6829a"]])

export default __exports__